/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CategoryDTOFromJSON, CategoryDTOToJSON, } from './CategoryDTO';
/**
 * Check if a given object implements the Data interface.
 */
export function instanceOfData(value) {
    return true;
}
export function DataFromJSON(json) {
    return DataFromJSONTyped(json, false);
}
export function DataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'categories': json['categories'] == null ? undefined : (json['categories'].map(CategoryDTOFromJSON)),
    };
}
export function DataToJSON(json) {
    return DataToJSONTyped(json, false);
}
export function DataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'categories': value['categories'] == null ? undefined : (value['categories'].map(CategoryDTOToJSON)),
    };
}
